export default __webpack_public_path__ + "static/media/spin-button.48995a03.gif";